export default {
  loggedIn: {
    deposit: 'Depositar',
    withdraw: 'Retirar',
    balance: 'Saldo total',
    cash: 'Efectivo',
    bonus: 'Bono',
    withdrawable: 'Retirable',
    transaction: 'Transacción',
    history: 'Historial',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Bóveda',
    notification: 'Notificación',
    affiliate: 'Afiliado - Gana $5,000 Al Mes',
    affiliateTitle: 'Afiliado',
    affiliateBadge: 'Gana $5,000 Al Mes',
    settings: 'Configuración',
    currency: 'Moneda',
    language: 'Idioma',
    liveSupport: 'Soporte en Vivo',
    signOut: 'Cerrar sesión'
  }
};
